module.exports = __webpack_public_path__ + "static/media/experiment 1-1.9344897d.png";